import { createFileRoute } from "@tanstack/react-router";

import RecurringPurchases from "../../-components/Purchase/Recurring/RecurringPurchases";

export const Route = createFileRoute("/_authenticated/trade/purchase/recurring/")({
  component: RecurringPurchases,
  context: () => ({ permissions: "trade.purchase.recurring" }),
});
